import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/dashboards`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  createDashboard({ commit }, payload: { userId: number}) {
    return axiosInstance.post(`${baseUrl}/`, payload)
      .then((data) => data.data);
  },
  getDashboardsByUserId({ commit }, payload: {  params: { userId: number} }) {
    return axiosInstance.get(`${baseUrl}/`, { params: payload.params })
      .then((data) => data.data);
  },
  createWidget({ commit }, payload: { dashboardId: number, userId: number}) {
    return axiosInstance.post(`${baseUrl}/${payload.dashboardId}/widgets`, payload)
      .then((data) => data.data);
  },
  getWidgetsByDashboardId({ commit }, payload: { dashboardId: number, params: {} }) {
    return axiosInstance.get(`${baseUrl}/${payload.dashboardId}/widgets`, { params: payload.params })
      .then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
